import { useLazyQuery, useQuery, useMutation } from "@apollo/client/react"; import React, { Fragment, useState, useEffect } from "react";

import { useLocation } from 'react-router-dom';
import { CustomChip } from "../../../components/chip/Chip";
import { CustomButton } from '../../../components/customButton/CustomButton';
import { Box, Grid, CardContent, Card } from '@mui/material';
import PropTypes from 'prop-types';
import { RenderInputsRowByType } from "../../../components/formGroupGenerator/RenderInputRowByType";
import { Historial } from "./Historial";
import { adaptEstadosBitacoraArray, GET_ESTADOS_HISTORIAL } from '../../../data/graphQL/queries/Traditum/getEstadosHistorial';
import { RESETEAR_SOLICITUD } from '../../../data/graphQL/mutations/Traditum/resetearSolicitud';
import './traditumDetalle.scss';
import moment from "moment";

export const TraditumDetalleContent = () => {
  const location = useLocation();
  const stateData = location.state;
  const [solicitud, setSolicitud] = useState({
    ...stateData?.datosSolicitud,
    fechaPrescripcion: moment(stateData?.datosSolicitud?.fechaPrescripcion).format("yyyy-MM-DD"),
    fechaRealizacion: moment(stateData?.datosSolicitud?.fechaRealizacion).format("yyyy-MM-DD")
  });
  const [estados, setEstados] = useState([...(stateData?.estados || [])]);
  const [bitacora, setBitacora] = useState([]);
  const [estadosChip] = useState({
    1: { isYellow: true },
    2: { isYellow: true },
    3: { isYellow: true },
    4: { isRed: true },
    5: { isGreen: true },
    6: { isRed: true },
    7: { isRed: true },
    8: { isRed: true }
  });

  function ItemR(props) {
    const { sx, ...other } = props;
    return (
      <Box
        sx={{
          bgcolor: (theme) => theme.palette.mode === 'dark' ? '#101010' : '#fff',
          color: (theme) => theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
          borderRadius: 0,
          fontSize: '0.75rem',
          ...sx,
          padding: 1
        }}
        {...other} />);


  }

  ItemR.propTypes = {
    sx: PropTypes.oneOfType([
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
      ),
      PropTypes.func,
      PropTypes.object]
    )
  };

  const getEstado = (idEstado) => {
    const color = estadosChip[idEstado];
    const estadoName = !estados ? '' : estados?.find((x) => x.id === idEstado)?.displayName;
    return (
      <ItemR>
        <CustomChip
          label={estadoName}
          {...color} />

      </ItemR>);

  };

  const [getHistorial, { loading: historialLoading, data: dataHistorial }] = useLazyQuery(GET_ESTADOS_HISTORIAL, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    getHistorial({
      variables: {
        idSolicitud: solicitud?.idSolicitud
      }
    });
  }, [solicitud?.idSolicitud]);

  useEffect(() => {
    if (!dataHistorial) return;

    setBitacora(dataHistorial.traditumBitacora?.valorEsperado);
  }, [dataHistorial]);

  const [resetearEstado] = useMutation(RESETEAR_SOLICITUD, {
    variables: {
      idSolicitud: solicitud?.idSolicitud
    }
  });

  const handleClickResetear = async () => {
    await resetearEstado();
    getHistorial();
  };

  return (
    <>
      <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
        <CardContent>
          <Grid container columns={100} columnSpacing={2} rowSpacing={1}>
            {inputsCabecera.map((input, index) => {
              return (
                <Grid key={index} size={{ xs: 100, sm: 50, md: 20, lg: 20 }}>
                  {
                    input.name === 'resetear' ?
                      solicitud?.idEstado !== 6 ?
                        null :

                        <CustomButton
                          variant={'outlined'}
                          onClick={() => handleClickResetear()}
                          size="small"
                          isLoading={historialLoading}
                          sx={{ margin: '5px' }}>

                          {input.displayName}
                        </CustomButton> :

                      <ItemR>
                        <strong>{input.displayName}</strong>
                      </ItemR>
                  }
                  {input.name === 'idEstado' ?
                    getEstado(bitacora[0]?.idEstado) :

                    input.name !== 'resetear' ?
                      <ItemR>
                        {solicitud[input.name]}
                      </ItemR> :
                      null
                  }
                </Grid>);

            })}
          </Grid>
        </CardContent>
      </Card>
      <div className='information'>
        <Card sx={{ width: '48%' }} elevation={1}>
          <CardContent>
            <Grid
              container
              columns={100}
              columnSpacing={1}
              rowSpacing={1}>

              {inputsDetalle.map((section, index) => {
                return <>
                  <h4 className="sectionTitle">{section.sectionName}</h4>
                  {section.inputs.map((input, index) => {
                    return <Fragment key={section.sectionName + index}>
                      <RenderInputsRowByType
                        key={input.name + index}
                        input={input}
                        value={!!input?.value ? input.value : solicitud[input.name]} />

                    </Fragment>;
                  })
                  }
                </>;
              })}
            </Grid>
          </CardContent>
        </Card>
        <Card className="informationRight" sx={{ width: '48%' }} elevation={2}>
          <Historial
            estados={estados}
            bitacora={bitacora} />

        </Card>
      </div>
    </>);

};

const inputsCabecera = [
  {
    displayName: '#',
    name: 'idSolicitud'
  },
  {
    displayName: 'Evaluación',
    name: 'idEvaluacion'
  },
  {
    displayName: 'HC',
    name: 'idPaciente'
  },
  {
    displayName: 'Paciente',
    name: 'paciente'
  },
  {
    displayName: 'Resetear',
    name: 'resetear'
  },
  {
    displayName: 'Código de cliente',
    name: 'idCliente'
  },
  {
    displayName: 'Cliente',
    name: 'cliente'
  },
  {
    displayName: 'Estado',
    name: 'idEstado'
  }];


const inputsDetalle = [
  {
    sectionName: 'Información de la entidad efectora',
    inputs: [
      {
        displayName: 'Nro. Identificador',
        name: 'numeroIdentificadorEE',
        type: 'info',
        value: '30691182238',
        col: 30
      },
      {
        displayName: 'Tipo de Identificador',
        name: 'tipoIdentificadorEE',
        type: 'info',
        value: 'Nro. de CUIT/CUIL',
        col: 70
      },
      {
        displayName: 'Tipo de Prestador',
        name: 'tipoPrestadorEE',
        type: 'info',
        value: 'Medico',
        col: 30
      },
      {
        displayName: 'Provincia',
        name: 'provinciaEE',
        type: 'info',
        value: 'Cordoba',
        col: 70
      }]

  },
  {
    sectionName: 'Información del Prestador Efector',
    inputs: [
      {
        displayName: 'Nro. Identificador',
        name: 'numeroIdentificadorPE',
        type: 'info',
        value: '26927',
        col: 30
      },
      {
        displayName: 'Tipo de Identificador',
        name: 'tipoIdentificadorPE',
        type: 'info',
        value: 'Matricula Provincial',
        col: 70
      },
      {
        displayName: 'Tipo de Prestador',
        name: 'tipoPrestadorPE',
        type: 'info',
        value: 'Medico',
        col: 30
      },
      {
        displayName: 'Provincia',
        name: 'provinciaPE',
        type: 'info',
        value: 'Cordoba',
        col: 70
      }]

  },
  {
    sectionName: 'Información del Prestador Prescriptor',
    inputs: [
      {
        displayName: 'Nro. Identificador',
        name: 'identificadorPrestadorPrescriptor',
        type: 'info',
        col: 30
      },
      {
        displayName: 'Tipo de Identificador',
        name: 'tipoIdentificadorPP',
        type: 'info',
        value: 'Matricula Provincial',
        col: 70
      },
      {
        displayName: 'Tipo de Prestador',
        name: 'tipoPrestadorPP',
        type: 'info',
        value: 'Medico',
        col: 30
      },
      {
        displayName: 'Provincia',
        name: 'provinciaPP',
        type: 'info',
        value: 'Cordoba',
        col: 70
      }]

  },
  {
    sectionName: 'Información del Afiliado',
    inputs: [
      {
        displayName: 'Nro. Identificador',
        name: 'numeroAfiliado',
        type: 'info',
        col: 30
      },
      {
        displayName: 'Cod. Seguridad',
        name: 'codigoSeguridadA',
        type: 'info',
        value: '123',
        col: 70
      },
      {
        displayName: 'Apellido y Nombre',
        name: 'paciente',
        type: 'info',
        col: 70
      },
      {
        displayName: 'item',
        name: 'item',
        type: 'item',
        col: 30
      }]

  },
  {
    sectionName: 'Información de Validacion',
    inputs: [
      {
        displayName: 'Plan de Cobertura',
        name: 'planCuidado',
        type: 'info',
        col: 60
      },
      {
        displayName: 'item',
        name: 'item',
        type: 'item',
        col: 40
      },
      {
        displayName: 'Fecha Prescripcion',
        name: 'fechaPrescripcion',
        type: 'info',
        col: 60
      },
      {
        displayName: 'item',
        name: 'item',
        type: 'item',
        col: 40
      }]

  },
  {
    sectionName: 'Información del Diagnostico',
    inputs: [
      {
        displayName: 'Cod. Diagnostico',
        name: 'codigoDiagnosticoTraditum',
        type: 'info',
        col: 30
      },
      {
        displayName: 'item',
        name: 'item',
        type: 'item',
        col: 70
      }]

  },
  {
    sectionName: 'Información del Accidente',
    inputs: [
      {
        displayName: 'Tipo de Accidente',
        name: 'tipoAccidente',
        type: 'info',
        value: 'NO',
        col: 30
      },
      {
        displayName: 'item',
        name: 'item',
        type: 'item',
        col: 70
      }]

  },
  {
    sectionName: 'Detalle de Prestaciones',
    inputs: [
      {
        displayName: 'Cod. Practica',
        name: 'idPlanCuidado',
        type: 'info',
        col: 30
      },
      {
        displayName: 'Plan',
        name: 'planCuidado',
        type: 'info',
        col: 70
      },
      {
        displayName: 'CantidadSolicitada',
        name: 'cantidadSolicitada',
        type: 'info',
        col: 30
      },
      {
        displayName: 'Fecha Realizacion',
        name: 'fechaRealizacion',
        type: 'info',
        col: 70
      }]

  }];